import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { addSlideClass } from "./utils/func-add-slide-class";
import gsap from "gsap";
import { toggleActiveButton } from "./utils/func-toggle-active-button";

class Home {
	constructor() {
		this.newsWrapper = document.querySelector(".repeater--only-title");
		this.newsPosts = this.newsWrapper.querySelectorAll(".repetaer__post");
		this.instaFigure = [];
		this.instaCount = 0;
		this.instagramToken =
			"IGQWRPRWlSTnJkNm4tYlc2Q0phNG4zTmMzZAVQ1Vmh6THRIaEdKV0RDOVI1VkJzQmd4MVNCX213YnBIOGRpZAE1GTE00S25CaHIyeWtxYVE1amlreUxncXV4TkVoVWp3dzlmbk9ZAUDk3ZA05Ydk45RTNNdktZAa2I5UTgZD";
		this.intro();
		this.showroom();
		this.gallery();
		this.consultForm();
		this.newsList();
		this.updateNews();
		this.getInstaFeed();
		this.moreInstaFeed();
	}

	// 인트로 슬라이드
	intro() {
		const wrapper = document.querySelector(".home__intro");

		addSlideClass(wrapper);

		const swiper = new Swiper(wrapper, {
			modules: [Pagination, Autoplay],
			speed: 400,
			spaceBetween: 0,
			loop: true,
			pagination: {
				el: ".home__intro-pagination",
			},
			autoplay: {
				delay: 5000,
			},
		});
	}

	// 전시장소개 섹션 슬라이드
	showroom() {
		const showroomSwiper = new Swiper(".home__showroom", {
			speed: 800,
		});
	}

	gallery() {
		const parent = document.querySelector(".home-gallery");
		const pgEl = parent.querySelector(".home-gallery__pagination");
		const re = /\s*(?:,|$)\s*/;
		let pgName = pgEl.dataset.paginationName;
		pgName = pgName.split(re);

		addSlideClass(parent);
		const gallerySwiper = new Swiper(parent, {
			modules: [Pagination, Navigation],
			spaceBetween: 30,
			navigation: {
				prevEl: ".home-gallery__navigation--prev",
				nextEl: ".home-gallery__navigation--next",
			},
			pagination: {
				el: pgEl,
				clickable: true,
				bulletClass: "home-gallery__bullet",
				bulletActiveClass: "home-gallery__bullet--active",
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + pgName[index] + "</span>";
				},
			},
		});
	}

	// 상담 문의 란에서 메뉴를 유동적으로 생성하는 함수
	consultForm() {
		const productSelect = document.querySelector('select[name="product"]');
		const itemSelect = document.querySelector('select[name="product-item"]');

		const productSelectHTML = productSelect.innerHTML;
		const itemSelectHTML = itemSelect.innerHTML;

		let productArray = window.globalProductArray || [{ key: "Carnival Hi-Limousine", children: ["DIVINE 3", "DIVINE 5"] }];

		productArray.forEach((product) => {
			const keyOption = document.createElement("option");
			keyOption.value = product.key;
			keyOption.innerText = product.key;
			productSelect.append(keyOption);
		});

		productSelect.addEventListener("change", (e) => {
			const value = e.target.value;
			let isSelected = false;
			itemSelect.options.length = 0;
			productArray.forEach((e) => {
				if (value == e.key) {
					isSelected = true;
					e.children.forEach((item) => {
						const itemOption = document.createElement("option");
						itemOption.value = item;
						itemOption.innerText = item;
						itemSelect.append(itemOption);
					});
				}
			});
			if (!isSelected) {
				itemSelect.innerHTML = itemSelectHTML;
			}
		});

		toggleActiveButton();
	}

	// news 부분 gsap 애니메이션 설정
	newsList() {
		const activeClass = "repeater__post--active";
		[...this.newsPosts].forEach((post) => this.setNewsGsap(post));
	}

	// news 부분 gsap 애니메이션 설정
	setNewsGsap(post) {
		const tl = gsap.timeline({ paused: true });
		const contentWrapper = post.querySelector(".repeater__content-wrapper");
		const contentEl = post.querySelector(".repeater__content");
		const arrowEl = post.querySelector(".wp-block-read-more");
		tl.set(contentWrapper, {
			height: "auto",
		})
			.from(contentEl, {
				y: "-100%",
				duration: 0.75,
				ease: "Power2.easeOut",
			})
			.to(
				arrowEl,
				{
					rotate: 135,
				},
				"<"
			)
			.reverse();
		post.addEventListener("click", (element) => {
			tl.reversed(!tl.reversed());
			contentWrapper.classList.toggle("active");
		});
	}

	// 새로운 news post를 감지하여 해당 post에 애니메이션 추가
	updateNews() {
		const newsOpserver = new MutationObserver((mutationsList) => {
			for (const mutation of mutationsList) {
				// 추가된 dom이 있는지 조사
				if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
					// 새로 추가된 DOM 요소에 접근하고 작업을 수행합니다.
					const addedElement = mutation.addedNodes;
					this.newsWrapper.querySelectorAll(".repetaer__post").forEach((post) => this.setNewsGsap(post));
				}
			}
		});

		let option = {
			childList: true,
		};

		newsOpserver.observe(this.newsWrapper, option);
	}

	// 인스타그램 api로 다인모터스 계정 피드 가져오기
	instaFetch() {
		const response = fetch(`https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink,thumbnail_url&access_token=${instagramToken}`, {
			method: "GET",
			dataType: "jsonp",
		})
			.then((response) => response.json())
			.catch(function (error) {
				console.error("Error:", error);
			});
		return response;
	}

	async getInstaFeed() {
		const res = await this.instaFetch();
		res.data.forEach((e) => {
			this.instaFigure.push(e);
		});
		this.showInstaFeed(0);
	}

	showInstaFeed(count) {
		const contianer = document.querySelector(".home__sns");
		const MIN = count ? count * 9 : 0;
		const MAX = MIN + 9;
		for (let i = MIN; i < MAX; i++) {
			const target = this.instaFigure[i];
			// dom 정의
			const figure = document.createElement("a");
			figure.href = target.permalink;
			figure.classList.add("home__sns-item");
			const img = document.createElement("img");

			img.src = target.media_url;
			if (this.instaFigure[i].media_type == "VIDEO") {
				img.src = target.thumbnail_url;
			}

			figure.appendChild(img);
			contianer.appendChild(figure);
		}
	}

	// 버튼 클릭 시 추가 인스타그램 피드 가져오기
	moreInstaFeed() {
		const button = document.querySelector(".home__sns-more > .wp-element-button");
		button.addEventListener("click", (e) => {
			if (this.instaCount < 1) {
				e.preventDefault();
				this.instaCount++;
				this.showInstaFeed(this.instaCount);
			}
		});
	}
}

export default Home;
